/* THE MEN THING — AI Search floating launcher (THEME-ASSET build)
 * Same code as /apps/ai-search/launcher, but served as a theme asset so the
 * storefront speed app (SPDN / "delay JavaScript") can't neuter it — theme
 * assets under /cdn/shop/t/ are not delayed, so the button always renders.
 *
 * INSTALL (2 steps):
 *   1. Shopify admin → Online Store → Themes → ⋯ → Edit code →
 *      Assets → "Add a new asset" → upload this file (tmt-ai-launcher.js).
 *   2. In layout/theme.liquid, just before </body>, add:
 *        <script src="{{ 'tmt-ai-launcher.js' | asset_url }}" defer></script>
 *      and REMOVE the old  <script src="/apps/ai-search/launcher" ...>  tag
 *      (the one the speed app was turning into type="text/spdnscript").
 *
 * Optional data-attributes on the <script> tag:
 *   data-position="right" | "left"   (default right wall, vertically centered)
 *   data-color="#111111"             (solid button colour, overrides gradient)
 *   data-label="AI Search"           (tooltip / a11y label)
 */
(function () {
  if (window.__tmtAiLauncher) return; // guard against double-injection
  window.__tmtAiLauncher = true;

  var script = document.currentScript || (function () {
    var s = document.getElementsByTagName("script");
    return s[s.length - 1];
  })();
  var cfg = (script && script.dataset) || {};
  var POS = (cfg.position || "right").toLowerCase(); // "right" | "left" wall, vertically centered
  // Fill: a gradient by default (matches the floating-tab look); override with
  // data-gradient="..." or a solid data-color="#111".
  var BG = cfg.gradient || cfg.color || "linear-gradient(135deg,#1a1a1a 0%,#c2261d 100%)"; // TMT black→red
  var GLOW = cfg.glow || "194,38,29"; // rgb (brand red) for the soft halo around the tab
  var LABEL = cfg.label || "AI Search";
  var BASE = cfg.base || "/apps/ai-search"; // App Proxy base → widget lives here
  var sideRight = POS.indexOf("left") === -1;

  // ── icon (sparkle + magnifier, matches the widget heading) ──
  var ICON =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<circle cx="11" cy="11" r="7"/><path d="M21 21l-4.35-4.35"/></svg>';
  var CLOSE_ICON =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';

  // ── styles ──
  var css =
    // Icon-only gradient tab stuck to the side wall, vertically centered, with a soft glow.
    ".tmtais-fab{position:fixed;" + (sideRight ? "right:0" : "left:0") + ";top:50%;transform:translateY(-50%);z-index:2147483000;" +
    "display:inline-flex;align-items:center;justify-content:center;width:56px;height:58px;padding:0;border:0;" +
    "border-radius:" + (sideRight ? "29px 0 0 29px" : "0 29px 29px 0") + ";" +
    "background:" + BG + ";color:#fff;cursor:pointer;" +
    "box-shadow:0 10px 28px rgba(" + GLOW + ",.5), 0 0 40px rgba(" + GLOW + ",.30);" +
    "transition:transform .18s ease,box-shadow .18s ease,filter .18s ease;-webkit-tap-highlight-color:transparent;}" +
    ".tmtais-fab:hover{transform:translateY(-50%) translateX(" + (sideRight ? "-4px" : "4px") + ");" +
    "box-shadow:0 14px 36px rgba(" + GLOW + ",.62), 0 0 54px rgba(" + GLOW + ",.42);filter:brightness(1.06);}" +
    ".tmtais-fab:active{transform:translateY(-50%) scale(.96);}" +
    ".tmtais-fab svg{width:27px;height:27px;flex:0 0 auto;}" +
    ".tmtais-ov{position:fixed;inset:0;z-index:2147483001;display:none;align-items:flex-start;justify-content:center;" +
    "background:rgba(15,15,17,.55);-webkit-backdrop-filter:blur(3px);backdrop-filter:blur(3px);padding:5vh 16px 16px;}" +
    ".tmtais-ov.is-open{display:flex;}" +
    ".tmtais-panel{position:relative;width:min(920px,96vw);max-height:90vh;display:flex;flex-direction:column;" +
    "background:#fff;border-radius:16px;overflow:hidden;box-shadow:0 30px 80px rgba(0,0,0,.4);animation:tmtais-in .18s ease;}" +
    "@keyframes tmtais-in{from{opacity:0;transform:translateY(12px) scale(.99);}to{opacity:1;transform:none;}}" +
    ".tmtais-head{display:flex;align-items:center;justify-content:space-between;padding:14px 16px;border-bottom:1px solid #eee;flex:0 0 auto;}" +
    ".tmtais-head b{font:700 16px/1 -apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,Helvetica,Arial,sans-serif;color:#111;display:flex;align-items:center;gap:8px;}" +
    ".tmtais-head b svg{width:18px;height:18px;}" +
    ".tmtais-x{display:inline-flex;align-items:center;justify-content:center;width:34px;height:34px;border:0;border-radius:8px;background:#f3f3f3;color:#333;cursor:pointer;}" +
    ".tmtais-x:hover{background:#e9e9e9;}.tmtais-x svg{width:18px;height:18px;}" +
    ".tmtais-body{flex:1 1 auto;overflow-y:auto;-webkit-overflow-scrolling:touch;padding:14px 16px 18px;}" +
    ".tmtais-frame{width:100%;border:0;display:block;min-height:420px;}" +
    "@media(max-width:600px){.tmtais-ov{padding:0;}.tmtais-panel{width:100vw;max-height:100vh;height:100vh;border-radius:0;}}";

  var style = document.createElement("style");
  style.textContent = css;
  document.head.appendChild(style);

  // ── floating button ──
  var fab = document.createElement("button");
  fab.type = "button";
  fab.className = "tmtais-fab";
  fab.setAttribute("aria-label", LABEL);
  fab.setAttribute("title", LABEL); // hover tooltip (icon-only button)
  fab.innerHTML = ICON;

  // ── modal ──
  var ov = document.createElement("div");
  ov.className = "tmtais-ov";
  ov.setAttribute("role", "dialog");
  ov.setAttribute("aria-modal", "true");
  ov.setAttribute("aria-label", "AI product search");
  ov.innerHTML =
    '<div class="tmtais-panel">' +
    '<div class="tmtais-head"><b>' + ICON + "AI Powered Search</b>" +
    '<button type="button" class="tmtais-x" aria-label="Close search">' + CLOSE_ICON + "</button></div>" +
    '<div class="tmtais-body"><iframe class="tmtais-frame" title="AI product search" loading="lazy"></iframe></div>' +
    "</div>";

  var frame = ov.querySelector(".tmtais-frame");
  var loaded = false;
  // The widget auto-sizes its own iframe height; mirror that here.
  window.addEventListener("message", function (e) {
    if (e && e.data && e.data.tmtaisHeight) frame.style.height = e.data.tmtaisHeight + "px";
  });

  function open() {
    if (!loaded) { frame.src = BASE + "/widget?focus=1"; loaded = true; } // lazy load on first open
    ov.classList.add("is-open");
    document.documentElement.style.overflow = "hidden";
    // focus the search input inside the (same-origin) iframe once it's ready
    setTimeout(function () {
      try { frame.contentWindow.document.querySelector(".aisearch__input").focus(); } catch (e) {}
    }, 350);
  }
  function close() {
    ov.classList.remove("is-open");
    document.documentElement.style.overflow = "";
  }

  fab.addEventListener("click", open);
  ov.addEventListener("click", function (e) { if (e.target === ov) close(); });
  ov.querySelector(".tmtais-x").addEventListener("click", close);
  document.addEventListener("keydown", function (e) { if (e.key === "Escape" && ov.classList.contains("is-open")) close(); });

  // Don't show the floating search tab on the CART page — the shopper is there to
  // check out, not search. Matches /cart (and /cart/) or the cart template body.
  function onCartPage() {
    try {
      if (/\/cart\/?$/.test(location.pathname)) return true;
      if (document.body && /(^|\s)template-cart(\s|$)/.test(document.body.className)) return true;
    } catch (e) {}
    return false;
  }

  function mount() {
    if (onCartPage()) return; // hide the floating AI Search icon on the cart page
    document.body.appendChild(fab);
    document.body.appendChild(ov);
  }
  if (document.body) mount();
  else document.addEventListener("DOMContentLoaded", mount);
})();